import { useQuestionSettings } from "src/reducers/exam";
import { useQuestionsListSettings } from "src/reducers/questions";

import { Answers, type AnswersProps } from "./Answers";

type AnswersTypeProps = Omit<AnswersProps, "isStatsVisible"> &
	Record<string, unknown>;

export function ExamAnswers(props: AnswersTypeProps) {
	const { state } = useQuestionSettings();
	const { statistics: isStatsVisible } = state.settings;

	return <Answers {...props} isStatsVisible={isStatsVisible} />;
}

export function LocalAnswers(props: AnswersTypeProps) {
	const { state } = useQuestionsListSettings();
	const { statistics: isStatsVisible } = state.settings;

	return <Answers {...props} isStatsVisible={isStatsVisible} />;
}
